<script setup lang="ts">
defineProps<{
  disabled?: boolean;
}>();
</script>

<template>
  <button class="project_items_container" :disabled="disabled">
    <span class="button_choice__content">
      <span class="body_med"><slot name="title"></slot></span>
      <span class="text-secondary-color sub_title"><slot name="subTitle"></slot></span>
    </span>
    <img src="/icons/generic/arrow_next.svg" alt="" />
  </button>
</template>

<style scoped lang="scss">
.button_choice__content {
  @apply flex flex-col items-start text-start;
}

.project_items_container {
  @apply flex p-[16px] items-center justify-between w-full cursor-pointer;
  background: var(--white-main);
  border: 1px solid var(--grey-lightest);
  border-radius: 8px;

  &:not([disabled]) {
    &:hover {
      border-color: var(--primary-blue-color);
    }

    &:has(input:checked) {
      border-color: var(--primary-blue-color);
    }
  }

  &:disabled {
    color: var(--text-tertiary-color) !important;

    .sub_title {
      color: var(--text-tertiary-color) !important;
    }
  }
}
</style>
